import {
    URLAPI,
    VEHICLE_MAINTENANCE_PATH,
    VEHICLE_MAINTENANCE_ITEM_PATH,
    VEHICLE_MAINTENANCE_CREATE_PATH,
    VEHICLE_MAINTENANCE_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _get_all_vehicle_maintenance: {
        data: [],

        status: 0,
        message: {},
    },

    _create_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
    _update_vehicle_maintenance: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_VEHICLE_MAINTENANCE = "GET_ALL_VEHICLE_MAINTENANCE";
export const CREATE_VEHICLE_MAINTENANCE = "CREATE_VEHICLE_MAINTENANCE";
export const UPDATE_VEHICLE_MAINTENANCE = "UPDATE_VEHICLE_MAINTENANCE";

export const vehicle_maintenance_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _get_all_vehicle_maintenance: action.payload,
            };
        case CREATE_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _create_vehicle_maintenance: action.payload,
            };
        case UPDATE_VEHICLE_MAINTENANCE:
            return {
                ...state,
                _update_vehicle_maintenance: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllVehicleMaintenance = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${VEHICLE_MAINTENANCE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_VEHICLE_MAINTENANCE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_VEHICLE_MAINTENANCE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getItemVehicleMaintenance = async (token, id) => {
    return await axios.get(`${URLAPI}${VEHICLE_MAINTENANCE_ITEM_PATH}${id}/`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};

export const createVehicleMaintenance = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${VEHICLE_MAINTENANCE_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateVehicleMaintenance = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${VEHICLE_MAINTENANCE_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_VEHICLE_MAINTENANCE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_VEHICLE_MAINTENANCE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_vehicle_maintenance = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
